import image from 'assets/images/device/camera/image.png';
import DeviceImage from './DeviceImage';

const Camera = () => {
  return (
    <div id={'device-camera'}>
      <DeviceImage src={image} left={27} top={24} width={375} height={824} />
    </div>
  );
};

export default Camera;
